import { IOffer } from '../offer/types';

export function isSaleFromSuburbanBuilder({ isResale, offerType, dealType }: IOffer) {
  return dealType === 'sale' && offerType === 'suburban' && !isResale;
}
